// extracted by mini-css-extract-plugin
module.exports = {"faqComponent":"FaqSection_faqComponent__yFnx2"};